import script from "./diamondtv.vue?vue&type=script&lang=js"
export * from "./diamondtv.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__